var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { loadActiveAccount } from '@popup/steem/actions/active-account.actions';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { PopupContainer } from 'src/common-ui/popup-container/popup-container.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const WrongKeyPopup = ({ displayWrongKeyPopup, setDisplayWrongKeyPopup, navigateTo, loadActiveAccount, accounts, }) => {
    const [accountFound, setaccountFound] = useState(Object.keys(displayWrongKeyPopup)[0]);
    const [wrongKeysFound, setWrongKeysFound] = useState(Object.values(displayWrongKeyPopup)[0]);
    const skipKeyCheckOnAccount = () => __awaiter(void 0, void 0, void 0, function* () {
        let prevNoKeyCheck = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK);
        if (prevNoKeyCheck) {
            prevNoKeyCheck = Object.assign(Object.assign({}, displayWrongKeyPopup), prevNoKeyCheck);
        }
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK, prevNoKeyCheck !== null && prevNoKeyCheck !== void 0 ? prevNoKeyCheck : displayWrongKeyPopup);
        setDisplayWrongKeyPopup(undefined);
    });
    const loadAccountGotoManage = () => __awaiter(void 0, void 0, void 0, function* () {
        let actualNoKeyCheck = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK);
        if (actualNoKeyCheck && actualNoKeyCheck[accountFound]) {
            delete actualNoKeyCheck[accountFound];
        }
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK, actualNoKeyCheck);
        loadActiveAccount(accounts.find((account) => account.name === accountFound));
        navigateTo(Screen.SETTINGS_MANAGE_ACCOUNTS);
    });
    return (React.createElement(PopupContainer, { className: "wrong-key-popup" },
        React.createElement("div", { className: "popup-title" }, getMessage('html_popup_wrong_key_title', [
            wrongKeysFound.length !== 1 ? 's' : '',
        ])),
        React.createElement("div", { className: "caption", dangerouslySetInnerHTML: {
                __html: getMessage('html_popup_wrong_key_introduction', [
                    accountFound,
                    wrongKeysFound.join(', '),
                    wrongKeysFound.length !== 1 ? 's' : '',
                    wrongKeysFound.length !== 1 ? 's' : '',
                ]),
            } }),
        React.createElement("div", { className: "popup-footer" },
            React.createElement(ButtonComponent, { label: "popup_html_wrong_key_popup_do_nothing", onClick: skipKeyCheckOnAccount, type: ButtonType.ALTERNATIVE }),
            React.createElement(ButtonComponent, { label: "popup_html_wrong_key_popup_replace", onClick: loadAccountGotoManage }))));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    navigateTo,
    loadActiveAccount,
});
export const WrongKeyPopupComponent = connector(WrongKeyPopup);
